/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ArrayExtensions, ObjectExtensions, StringExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IProductSpecificationViewProps, IProductSpecificationData } from '@msdyn365-commerce-modules/product-specification';

const ProductSpecificationView: React.FC<IProductSpecificationViewProps> = props => {
    const { ProductSpecification, ProductSpecificationTableProps, ProductSpecificationTableBodyProps, productSpecificationResult } = props;
    const rowdata =
        productSpecificationResult &&
        ArrayExtensions.hasElements(productSpecificationResult) &&
        productSpecificationResult.filter(row => !ObjectExtensions.isNullOrUndefined(row));

    const productData = props.data as IProductSpecificationData;
    const allEligibleOffers = productData.product?.result?.ExtensionProperties
        ?.filter(ext => ext.Key === "AllEligibleOffers");
    
    const productTitle = props?.title as React.ReactElement;
    const updatedTitle = React.cloneElement(productTitle, {
        text: "Special Offer's"
    });
    
    if (allEligibleOffers && allEligibleOffers.length > 0) {
        productData.productSpecificationData.result?.forEach(attribute => {
            if (attribute?.Name?.toLowerCase() === "offers" && !StringExtensions.isNullOrWhitespace(allEligibleOffers[0].Value?.StringValue)) {
                attribute.TextValue = allEligibleOffers[0].Value?.StringValue?.replace(/, ?/g, ',<br />');
            }
        });
    }

    return rowdata && ArrayExtensions.hasElements(rowdata) ? (
        
        <Module {...ProductSpecification}>
            
            {updatedTitle}
            <Node {...ProductSpecificationTableProps}>
                <Node {...ProductSpecificationTableBodyProps}>{rowdata}</Node>
            </Node>
        </Module>
        
    ) : null;
};

export default ProductSpecificationView;
